import React, { useContext, useState } from "react";
import * as notify from "../../../shared/notify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";

import { PhotographyContext } from "../../../contexts/photography";
import { useInput } from "../../../shared/hooks/form-fields";
import { Select } from "../../form-inputs/inputs";
import { removeLocaleReference, updateLocaleReference } from "../lib/imageData";
import { DEFAULT_LOCALE } from "../../photography/lib/helpers";

const LocaleShotSelector = ({ relationships, photoWipKey, shot, readOnly, disabled }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [localeRelationships, setLocaleRelationships] = useState(relationships || []);
    const localeSelect = useInput("");
    const imageViewSelect = useInput("");
    const { lookups } = useContext(PhotographyContext);

    const addLocaleShot = async () => {
        if (isLoading) {
            return;
        }

        if (!localeSelect.value || !imageViewSelect.value) {
            notify.error("Both locale and image view are required");

            return;
        }

        if (localeSelect.value === (shot.localeCode || DEFAULT_LOCALE.value)) {
            notify.error("You can not use the same locale for a reference");

            return;
        }

        var hasValue = localeRelationships.some((r) => r.referencedImageViewCode === imageViewSelect.value && r.localeCode === localeSelect.value);

        if (hasValue) {
            notify.error("Value already exists");

            return;
        }

        setIsLoading(true);
        const newRelationships = [
            {
                localeCode: localeSelect.value,
                referencedImageViewCode: imageViewSelect.value,
            },
        ];
        const response = await updateLocaleReference(photoWipKey, shot.key, newRelationships);

        if (!response) {
            return;
        }

        setLocaleRelationships([...localeRelationships, ...newRelationships]);
        localeSelect.reset();
        imageViewSelect.reset();
        setIsLoading(false);
    };

    const removeRelationship = async (localeCode, referencedImageViewCode) => {
        const removeItem = {
            localeCode,
            referencedImageViewCode,
        };
        const response = await removeLocaleReference(photoWipKey, shot.key, removeItem);

        if (!response) {
            return;
        }

        const newRelationships = localeRelationships.filter(
            (r) => !(r.localeCode === removeItem.localeCode && r.referencedImageViewCode === removeItem.referencedImageViewCode)
        );
        setLocaleRelationships([...newRelationships]);
    };

    const selectedRelationships = localeRelationships.map((r, i) => {
        return (
            <div key={`${shot.key}_ref${i}`} className="selected-item">
                {r.localeCode} - {r.referencedImageViewCode}
                {!readOnly && (
                    <button
                        className="close"
                        onClick={() => {
                            removeRelationship(r.localeCode, r.referencedImageViewCode);
                        }}
                    >
                        <FontAwesomeIcon icon={faTimesCircle} />
                    </button>
                )}
            </div>
        );
    });

    return (
        <div>
            {!readOnly && (
                <div className="locale-shot-selector button-group">
                    <Select placeholder="Locale" options={lookups.localeOptions} {...localeSelect.bind} disabled={disabled} />
                    <Select placeholder="Image View" options={lookups.imageViewOptions} {...imageViewSelect.bind} disabled={disabled} />
                    <button className="button -primary" onClick={addLocaleShot} disabled={disabled || isLoading}>
                        +
                    </button>
                </div>
            )}
            <div className="selections">{selectedRelationships}</div>
        </div>
    );
};

export default LocaleShotSelector;
